import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Container from 'common/components/UI/Container';
import Image from 'common/components/Image';
import Link from 'common/components/Link';

import {
  Section,
  ContentWrapper,
  Copyright,
  Nav,
  SocialProfiles,
  Icons,
  LogoContainer,
} from './footer.style';


import ZetitLogo from 'common/assets/image/saasMinimal2/logo-black.png';


const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      saasMinimal2Json {
        footerNav {
          id
          url
          title
        }
        socialLinks {
          id
          link
          label
          icon {
            publicURL
          }
        }
      }
    }
  `);
  return (
    <Section>
      <Container>
        <ContentWrapper>
          <Copyright>
            {/* log start */}
            <LogoContainer>
              <figure>
                <Image src={ZetitLogo} alt="ZetitLogo" />
              </figure>
            </LogoContainer>
            {/* log end */}
            <p>
              Copyright © 2025 <Link href="#">ZetIt</Link>
            </p>
          </Copyright>
          <Nav>
            {data?.saasMinimal2Json?.footerNav?.map((item) => (
              <li key={item.id}>
                <Link href={item.url}>{item.title}</Link>
              </li>
            ))}
          </Nav>
          <SocialProfiles>
            <span>Social</span>
            <Icons>
              {data?.saasMinimal2Json?.socialLinks?.map((item) => (
                <Link key={item.id} href={item.url}>
                  <Image src={item.icon.publicURL} alt={item.label} />
                </Link>
              ))}
            </Icons>
          </SocialProfiles>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

export default Footer;
